module.exports = __webpack_public_path__ + "img/rateus.ab591f7d.png";